import { create } from "zustand";
import { persist } from "zustand/middleware";

export interface User {
  _id: string;
  name: string;
  email: string;
  phone: number;
  avatar: string;
  firstOrderDiscount: boolean;
  isBlocked: boolean;
  createdAt: string;
  updatedAt: string;
  status?: string;
  isFirstOrder?: boolean;
}

interface AuthState {
  user: User | null;
  accessToken: string | null;
  setUserData: (user: User, token: string) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      user: null,
      accessToken: null,
      setUserData: (user, token) => set({ user, accessToken: token }),
      logout: () => set({ user: null, accessToken: null }),
    }),
    {
      name: "auth-storage", // stored key in localStorage
    }
  )
);
